
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col items-center justify-center px-4">
      <div className="text-center max-w-2xl">
        <h1 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
          Enabling City Walk
        </h1>
        <p className="text-xl text-gray-600 mb-8">
          まちを歩きながら地域の魅力を発見し、感じたことを投稿・共有するアプリケーション
        </p>
        
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">重要なドキュメント</h2>
          <div className="space-y-4">
            <Link 
              to="/terms" 
              className="flex items-center justify-center gap-3 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <FileText className="w-5 h-5" />
              利用規約・プライバシーポリシーを確認
            </Link>
          </div>
        </div>
        
        <div className="text-gray-500 text-sm">
          <p>運営：イーネーブリングシティ協会</p>
          <p>東京都千代田区内神田2丁目6番7号</p>
        </div>
      </div>
    </div>
  );
}
